// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"00242833","833":"56cca25d"}[chunkId] + ".chunk.js";
};